export const APP_NAME = 'Xplooreze';
export const CONTACT_DETAILS = {
    phone: '8069409180',
    whatsapp: '9945693172',
    official_email: 'xplooreze@gmail.com',
    contact_email: 'contact@xplooreze.in',
    address: 'Bangalore, India',
    facebook: 'https://www.facebook.com/people/Xplooreze/61555574578205/',
    linkedin: 'https://www.linkedin.com/company/xplooreze/',
    instagram: 'https://www.instagram.com/xplooreze/'
};